export const DEFAULT_HEADLINE_CONTENT = {
    headline: {
        firstLine: 'The best way to find a',
        secondLine: 'Mortgage Adviser',
        mobile: {
            firstLine: 'The best way to find a',
            secondLine: 'Mortgage Adviser',
        },
    },
};

/* eslint quote-props: 0 */
export const HeadlineAdviserTypes = {
    'independent financial adviser': { text: 'Independent Financial Adviser' },
    'independent financial advisers': { text: 'Independent Financial Advisers' },
    'independent financial advisor': { text: 'Independent Financial Advisor' },
    'independent financial advisors': { text: 'Independent Financial Advisors' },

    'financial adviser': { text: 'Financial Adviser' },
    'financial advisers': { text: 'Financial Advisers' },
    'financial advisor': { text: 'Financial Advisor' },
    'financial advisors': { text: 'Financial Advisors' },
    'financial planner': { text: 'Financial Planner' },
    'financial planners': { text: 'Financial Planners' },

    'mortgage adviser': { text: 'Mortgage Adviser' },
    'mortgage advisers': { text: 'Mortgage Advisers' },
    'mortgage advisor': { text: 'Mortgage Advisor' },
    'mortgage advisors': { text: 'Mortgage Advisor' },
    'mortgage broker': { text: 'Mortgage Broker' },
    'mortgage brokers': { text: 'Mortgage Brokers' },
    'mortgage advice': { text: 'Mortgage Advice' },
    'independent mortgage advice': { text: 'Independent Mortgage Advice' },
    'independent mortgage adviser': { text: 'Independent Mortgage Adviser' },
    'independent mortgage advisers': { text: 'Independent Mortgage Advisers' },
    'independent mortgage advisor': { text: 'Independent Mortgage Advisor' },
    'independent mortgage advisors': { text: 'Independent Mortgage Advisor' },
    'independent mortgage broker': { text: 'Independent Mortgage Broker' },
    'independent mortgage brokers': { text: 'Independent Mortgage Brokers' },

    'investment adviser': { text: 'Investment Adviser' },
    'investment advisers': { text: 'Investment Advisers' },
    'investment advisor': { text: 'Investment Advisor' },
    'investment advisors': { text: 'Investment Advisors' },
    'investment planner': { text: 'Investment Planner' },
    'investment planners': { text: 'Investment Planners' },
    'independent investment planner': { text: 'Independent Investment Planner' },
    'independent investment planners': { text: 'Independent Investment Planners' },
    'financial advice': { text: 'Financial Advisers' },
    'investment advice': { text: 'Investment Advisers' },
    'retirement advice': { text: 'Retirement Advisers' },
    'ifa': { text: 'IFAs' },
    'ifas': { text: 'IFAs' },
    'annuity advisers': { text: 'Annuity Advisers' },
    'annuity advisors': { text: 'Annuity Advisors' },
    'annuity planners': { text: 'Annuity Planners' },
    'finance advisers': { text: 'Finance Advisers' },
    'finance planners': { text: 'Finance Planners' },

    'pension adviser': {
        text: 'Pension Adviser',
        value: 393,
    },
    'pension advisers': {
        text: 'Pension Advisers',
        value: 393,
    },
    'pension advisor': {
        text: 'Pension Advisor',
        value: 393,
    },
    'pension advisors': {
        text: 'Pension Advisors',
        value: 393,
    },
    'pension planner': {
        text: 'Pension Planner',
        value: 393,
    },
    'pension planners': {
        text: 'Pension Planners',
        value: 393,
    },
    'inheritance tax adviser': {
        text: 'Inheritance Tax Adviser',
        value: 558,
    },
    'inheritance tax advisers': {
        text: 'Inheritance Tax Advisers',
        value: 558,
    },
    'inheritance tax advisor': {
        text: 'Inheritance Tax Advisor',
        value: 558,
    },
    'inheritance tax advisors': {
        text: 'Inheritance Tax Advisors',
        value: 558,
    },
    'retirement advisers': {
        text: 'Retirement Advisers',
        value: 393,
    },
    'retirement advisors': {
        text: 'Retirement Advisors',
        value: 393,
    },
    'retirement planners': {
        text: 'Retirement Planners',
        value: 393,
    },
};

const capitaliseString = (value, all) => {
    if (all) {
        return value.split(' ').map(e => capitaliseString(e)).join(' ');
    }
    return value.charAt(0).toUpperCase() + value.slice(1);
};

export const getHeadlineContentFromQuery = (adviserType, consumerLocation) => {
    const content = DEFAULT_HEADLINE_CONTENT;

    if (!adviserType && !consumerLocation) {
        return content;
    }

    if (adviserType && HeadlineAdviserTypes[adviserType.toLowerCase()]) {
        content.headline.firstLine = `Find the best ${HeadlineAdviserTypes[adviserType.toLowerCase()].text}`;
        content.headline.mobile.firstLine = `Find the best ${HeadlineAdviserTypes[adviserType.toLowerCase()].text}`;

        if (consumerLocation) {
            content.headline.firstLine += ` in ${capitaliseString(consumerLocation, true)}`;
            content.headline.mobile.firstLine += ` in ${capitaliseString(consumerLocation, true)}`;
        }
    } else if (consumerLocation) {
        content.headline.firstLine =
            `Find the best ${HeadlineAdviserTypes['independent financial advisers'].text} in ` +
            `${capitaliseString(consumerLocation)}`;
        content.headline.mobile.firstLine =
            `Find the best ${HeadlineAdviserTypes['independent financial advisers'].text} in ` +
            `${capitaliseString(consumerLocation)}`;
    }

    content.headline.secondLine = '';
    content.headline.mobile.secondLine = '';

    return content;
};



// WEBPACK FOOTER //
// ./src/content/HeadlineContent.js